import React, { useEffect, useRef } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SectionTwoLuxury = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const leftRef = useRef<HTMLDivElement | null>(null);
  const rightRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(leftRef.current, {
        x: -100,
        opacity: 0,
        duration: 1.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });

      gsap.from(rightRef.current, {
        x: 100,
        opacity: 0,
        duration: 1.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        py: 4,
        background:
        //   "linear-gradient(135deg, #050510 0%, #0b0f2a 40%, #000 100%)",
          "linear-gradient(135deg, #000 0%, #000 40%, #000 100%)",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={10} alignItems="center">

          {/* LEFT SIDE */}
          <Grid item xs={12} md={6}>
            <Box ref={leftRef}>
              <Box

              >

                {/* IMAGE */}
                <Box
                  component="img"
                  src="https://dprstorage.b-cdn.net/RW/rw2webinar.png"
                  alt="Rajiv Williams"
                  sx={{
                    // width: "100%",
                    maxWidth: 440,
                    // height:200,
                    // mb: 6,
                    filter: "drop-shadow(0 40px 80px rgba(0,0,0,0.9))",
                  }}
                />
              </Box>

              {/* COACH INFO */}
              <Typography
                sx={{
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#fff",
                  mb: 1,
                }}
              >
                I will be your coach for 2 hours
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: 20,
                  fontWeight: 700,
                  background:
                    "linear-gradient(90deg, #fff 0%, #f6c77d 50%, #d8a24b 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  mb: 1,
                }}
              >
                Rajiv Williams
              </Typography>

              <Typography
                sx={{
                  fontSize: 15,
                  color: "#ccc",
                  mb: 3,
                }}
              >
                Sales Strategist | High-Value Sales Mentor | Business Coach
              </Typography>

              {/* RATING BLOCK */}
              <Box
                sx={{
                  mt: 3,
                  p: 3,
                  borderRadius: "16px",
                  background: "rgba(15,99,165,0.08)",
                  border: "1px solid rgba(15,99,165,0.4)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <Grid container alignItems="center" justifyContent='center' >

                  {/* LEFT SIDE - STARS */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      sx={{
                        fontSize: 22,
                        color: "#f6c77d",
                        letterSpacing: 3,
                      }}
                    >
                      ★★★★★
                    </Typography>
                  </Grid>

                  {/* RIGHT SIDE - CONTENT */}
                  <Grid item xs={12} md={8}>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#fff",
                        fontWeight: 600,
                      }}
                    >
                      70,000+ People Rated
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#ccc",
                      }}
                    >
                      My Programs with 4.96 Star
                    </Typography>
                  </Grid>

                </Grid>
              </Box>

            </Box>
          </Grid>

          {/* RIGHT SIDE – LAYER BOX ONLY */}
          <Grid item xs={12} md={6}>
            <Box ref={rightRef} sx={{ position: "relative" }}>

              {/* BACK LAYER */}
              <Box
                sx={{
                  position: "absolute",
                  top: 20,
                  left: 20,
                  width: "100%",
                  height: "100%",
                  background: "#0a0a0a",
                  borderRadius: "28px",
                }}
              />

              {/* MIDDLE LAYER */}
              <Box
                sx={{
                  position: "absolute",
                  top: 10,
                  left: 10,
                  width: "100%",
                  height: "100%",
                  background: "#111",
                  borderRadius: "28px",
                }}
              />

              {/* FRONT MAIN CARD */}
              <Box
                sx={{
                  position: "relative",
                  background: "#141414",
                  borderRadius: "28px",
                  p: 6,
                  border: "1px solid rgba(15,99,165,0.4)",
                  boxShadow: "0 40px 100px rgba(0,0,0,0.8)",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: 14,
                    letterSpacing: 3,
                    background:
                      "linear-gradient(90deg, #fff 0%, #f6c77d 50%, #d8a24b 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    textTransform: "uppercase",
                    mb: 4,
                  }}
                >
                  What Happens When You Join?
                </Typography>

                {[
                  "ou Unlock Secrets To Create Time & Wealth In Business",
                  "You Learn Strong Foundational Activities To Win In Your Business",
                  "Your Business Growth With Increased Revenue & Cashflow",
                  "More Profit, More Freedom, More Scale Guaranteed"
                ].map((item, index) => (
                  <Typography
                    key={index}
                    sx={{
                      color: "#fff",
                      fontSize: 16,
                      mb: 3,
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      textAlign:'start',
                      "&:before": {
                        content: '"✦"',
                        color: "#f6c77d",
                        fontSize: 18,
                      },
                    }}
                  >
                    {item}
                  </Typography>
                ))}

                {/* <Box
                  sx={{
                    mt: 5,
                    pt: 4,
                    borderTop: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 17,
                      color: "#ccc",
                      fontStyle: "italic",
                    }}
                  >
                    “Skills don’t create wealth. Positioning does.”
                  </Typography>

                  <Typography
                    sx={{
                      mt: 2,
                      color: "#0f63a5",
                      fontWeight: 600,
                    }}
                  >
                    — Rajiv Williams
                  </Typography>
                </Box> */}
              </Box>

            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default SectionTwoLuxury;